<template>
    <router-link
        class="m-pet-item"
        :to="'/' + petObject.Index"
        :class="getFrameClass(petObject.Quality)"
        target="_blank"
    >
        <div class="m-info">
            <el-image class="u-icon" :src="iconLink(petObject.IconID, client)" fit="fit"></el-image>
            <div class="u-text">
                <div class="u-name">{{ petObject.Name }}</div>
                <div class="u-rate">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="12" height="12" viewBox="0 0 12 12" fill="none" v-for="o in petObject.Star" :key="o" v-bind:class="'u-star'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g><mask id="a" fill="#fff"><use xlink:href="#path_0"/></mask><g mask="url(#a)"><path fill-rule="evenodd" d="M4.577 2.704C5.21 1.568 5.527 1 6 1c.473 0 .79.568 1.423 1.704l.165.294c.18.323.27.484.41.591.14.107.314.146.664.225l.318.072c1.23.279 1.845.417 1.992.888.146.47-.274.96-1.112 1.941l-.217.253c-.238.279-.357.418-.411.59-.053.173-.035.359 0 .73l.034.339c.126 1.308.19 1.962-.194 2.253-.382.291-.958.025-2.11-.505l-.298-.136c-.327-.152-.49-.227-.664-.227-.173 0-.337.075-.665.226l-.297.138c-1.152.53-1.728.795-2.11.505-.383-.292-.32-.946-.193-2.254l.033-.338c.036-.372.054-.558 0-.73-.053-.173-.173-.312-.411-.59l-.217-.254c-.839-.98-1.258-1.47-1.112-1.941.147-.47.762-.61 1.992-.888l.318-.072c.35-.079.524-.119.665-.225.14-.107.23-.268.41-.591l.163-.294z" fill="#ffa811"/></g></g><defs><path id="path_0" d="M0 0h12v12H0z"/></defs></svg>
                </div>
            </div>
        </div>

        <div class="u-desc" v-if="petObject.Desc" v-html="renderTextHtml(petObject.Desc)"></div>
    </router-link>
</template>

<script>
import { extractTextContent, iconLink } from "@jx3box/jx3box-common/js/utils";
import { __iconPath } from "@jx3box/jx3box-common/data/jx3box.json";
export default {
    props: {
        petObject: {},
    },

    data: function () {
        return {};
    },

    computed: {
        client() { 
            return this.$store.state.client;
        },
    },
    methods: {
        iconLink,
        renderTextHtml: function (Text) {
            let result = Text;
            const matches = Text.match(/<Text>(.*?)<\/text>/gims);
            if (!matches) return Text;
            for (let match of matches) {
                let text = extractTextContent(match);
                const html = text[0].text.replace(/\\n/g, "").replace(/\\/g, "");
                result = result.replace(match, html);
            }
            return result;
        },
        // 获取宠物边框样式
        getFrameClass: function (quality) {
            let className = "";
            if (quality) {
                switch (quality) {
                    case 2:
                        className = "pet-level-2";
                        break;
                    case 3:
                        className = "pet-level-3";
                        break;
                    case 4:
                        className = "pet-level-4";
                        break;
                    case 5:
                        className = "pet-level-5";
                        break;
                }
                return className;
            }
        },
    },
};
</script>

<style lang="less">
@import "~@/assets/css/pet/item.less";
</style>
